import { render, staticRenderFns } from "./ConfiguracionProceso.view.vue?vue&type=template&id=6b01cec2&scoped=true"
import script from "./ConfiguracionProceso.view.vue?vue&type=script&lang=js"
export * from "./ConfiguracionProceso.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b01cec2",
  null
  
)

export default component.exports